import { createContext } from "react";

const DynamicModuleContext = createContext<string | undefined>(undefined);

export default DynamicModuleContext;
